import axios from "axios";
const API_URL = "http://localhost:3001";

export const getCode = (secret: string) => {
    return axios.get(`${API_URL}/otp/${secret}`);
}
